export const GET_DOCTOR = 'doctor/getDoctor'
export const GET_DOCTORS = 'doctor/getDoctors'
export const ADD_DOCTOR = 'doctor/addDoctor'
export const UPDATE_DOCTOR = 'doctor/updateDoctor'
export const DELETE_DOCTOR = 'doctor/deleteDoctor'
export const ACTIVATE_DOCTOR = 'doctor/activateDoctor'
export const SET_UPDATE_DOCTOR = 'doctor/setDoctorForUpdate'
export const CHANGE_DOCTOR_ROLE = 'doctor/changeDoctorRole'
export const SERVER_ERROR_DOCTOR = 'doctor/errorDoctor'
